import { useEffect, useState } from "react";
import "./styles/loading.css";
import { LINE1, LINE2, LINE3, WORD_INTERVAL, HOLD_DURATION, FADE_DURATION } from "../constants.js"


const LINE1_WORDS = LINE1.split(" ");
const LAST_WORD_AT = LINE1_WORDS.length * WORD_INTERVAL;
const FADE_START = LAST_WORD_AT + HOLD_DURATION;

export default function Loading({ onDone }) {
  const [visibleCount, setVisibleCount] = useState(0);
  const [line2Visible, setLine2Visible] = useState(false);
  const [line3Visible, setLine3Visible] = useState(false);
  const [containerOpacity, setContainerOpacity] = useState(1);

  useEffect(() => {
    const wordTimers = LINE1_WORDS.map((_, i) =>
      setTimeout(() => setVisibleCount(i + 1), (i + 1) * WORD_INTERVAL)
    );

    const line2Timer = setTimeout(() => {
      setLine2Visible(true);
    }, LAST_WORD_AT + WORD_INTERVAL + 500);

    const line3Timer = setTimeout(() => {
      setLine3Visible(true);
    }, LAST_WORD_AT + WORD_INTERVAL + 1500);

    const fadeTimer = setTimeout(() => {
      setContainerOpacity(0);
      setTimeout(() => onDone?.(), FADE_DURATION);
    }, FADE_START);

    return () => {
      wordTimers.forEach(clearTimeout);
      clearTimeout(line2Timer);
      clearTimeout(line3Timer);
      clearTimeout(fadeTimer);
    };
  }, [onDone]);

  return (
    <div className="loading-container" style={{ opacity: containerOpacity }}>
      <div className="loading-main-block">
        <div className="loading-line1">
          {LINE1_WORDS.map((word, i) => (
            <span
              key={i}
              className={`loading-word ${i < visibleCount ? "visible" : ""} ${i >= 3 ? "bold" : ""}`}
            >
              {word}
            </span>
          ))}
        </div>

        <div className={`loading-line2 ${line2Visible ? "visible" : ""}`}>
          {LINE2}
        </div>
      </div>

      <div className={`loading-line3 ${line3Visible ? "visible" : ""}`}>
        {LINE3}
      </div>
    </div>
  );
}